/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Damaged areas in the vehicle. * Car and no glass damages '00_DLI': 'Front left bumper and light cluster' '01_DLI': 'Front bumper and grill' '02_DLI': 'Front right bumper and light cluster' '10_DLI': 'Front left wing and wheel area' '11_DLI': 'Bonnet' '12_DLI': 'Front right wing and wheel area' '21_DLI': 'Roof' '40_DLI':'Rear left wing and wheel area' '41_DLI':'Boot' '42_DLI':'Rear right wing and wheel area' '50_DLI':'Rear left bumper and light cluster' '51_DLI':'Rear bumper' '52_DLI':'Rear right bumper and light cluster' * Car and glass damages '01_DLI': 'Front' '10_DLI': 'Front left wing' '12_DLI': 'Front right wing' '21_DLI': 'Roof' '50_DLI': 'Rear left' '52_DLI': 'Rear right' * Moto 'MB10_DLI': 'Left side, front end' 'MB11_DLI': 'Right side, front end' 'MB20_DLI': 'Left side center' 'MB21_DLI': 'Right side center' 'MB30_DLI': 'Left side rear end' 'MB31_DLI': 'Right side rear end'
 */
export type DamageAreas =
  | '00_DLI'
  | '01_DLI'
  | '02_DLI'
  | '10_DLI'
  | '11_DLI'
  | '12_DLI'
  | '21_DLI'
  | '40_DLI'
  | '41_DLI'
  | '42_DLI'
  | '50_DLI'
  | '51_DLI'
  | '52_DLI'
  | 'MB10_DLI'
  | 'MB11_DLI'
  | 'MB20_DLI'
  | 'MB21_DLI'
  | 'MB30_DLI'
  | 'MB31_DLI';

export const DamageAreas = {
  _00DLI: '00_DLI' as DamageAreas,
  _01DLI: '01_DLI' as DamageAreas,
  _02DLI: '02_DLI' as DamageAreas,
  _10DLI: '10_DLI' as DamageAreas,
  _11DLI: '11_DLI' as DamageAreas,
  _12DLI: '12_DLI' as DamageAreas,
  _21DLI: '21_DLI' as DamageAreas,
  _40DLI: '40_DLI' as DamageAreas,
  _41DLI: '41_DLI' as DamageAreas,
  _42DLI: '42_DLI' as DamageAreas,
  _50DLI: '50_DLI' as DamageAreas,
  _51DLI: '51_DLI' as DamageAreas,
  _52DLI: '52_DLI' as DamageAreas,
  MB10DLI: 'MB10_DLI' as DamageAreas,
  MB11DLI: 'MB11_DLI' as DamageAreas,
  MB20DLI: 'MB20_DLI' as DamageAreas,
  MB21DLI: 'MB21_DLI' as DamageAreas,
  MB30DLI: 'MB30_DLI' as DamageAreas,
  MB31DLI: 'MB31_DLI' as DamageAreas,
};
